/* eslint-disable max-len */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: ()=>_default
});
const lang = {
    common: {
        fetching: 'Récupération...',
        refresh: 'Rafraîchir',
        refresh_success: 'Rafraîchissement réussi',
        refreshed: 'Rafraîchi',
        rewards_placeholder_title: 'Aucune récompense disponible',
        rewards_placeholder_subtitle: 'Vous n’avez aucune récompense disponible pour le moment, veuillez rafraîchir ou vérifier à nouveau plus tard',
        offers_placeholder_title: 'Aucune offre disponible',
        offers_placeholder_subtitle: 'Vous n’avez aucune offre pour le moment, veuillez rafraîchir ou vérifier à nouveau plus tard',
        milestones_placeholder_title: 'Aucune étape disponible',
        milestones_placeholder_subtitle: 'Vous n’avez aucune étape à débloquer pour le moment, veuillez rafraîchir ou vérifier à nouveau plus tard',
        messages_placeholder_title: 'Aucun nouveau message',
        messages_placeholder_subtitle: 'Vous n’avez aucun nouveau message pour le moment, veuillez rafraîchir ou vérifier à nouveau plus tard',
        purchases_placeholder_title: 'Aucun historique d’achat',
        purchases_placeholder_subtitle: 'Revenez après votre prochain achat ! ou cliquez sur rafraîchir',
        redemptions_placeholder_title: 'Aucun historique de rédemption',
        redemptions_placeholder_subtitle: 'Revenez après votre première rédemption ! ou cliquez sur rafraîchir'
    },
    validation: {
        email_required: 'l\'email est requis',
        email_invalid: 'format d\'email invalide',
        code_required: 'le code est requis',
        code_invalid: 'format de code invalide',
        name_required: 'le nom est requis',
        name_long: 'le nom est trop long',
        name_invalid: 'format de nom invalide',
        number_required: 'le numéro de carte est requis',
        number_short: 'le numéro de carte est trop court',
        number_long: 'le numéro de carte est trop long',
        number_invalid: 'format de numéro de carte invalide',
        zip_required: 'le code postal est requis',
        zip_invalid: 'format de code postal invalide',
        cvv_required: 'le CVV est requis',
        cvv_invalid: 'format de CVV invalide',
        expiry_required: 'la date d\'expiration est requise',
        expiry_invalid: 'date invalide'
    },
    auth: {
        ten_dlc: {
            four_pin: {
                title: 'Bienvenue chez {0} !',
                description: 'Cliquez sur le bouton pour recevoir votre code de vérification.'
            },
            six_pin: {
                title: 'Bienvenue chez {0} !',
                description: 'Cliquez sur le bouton pour recevoir votre code de vérification.'
            },
            birthday: {
                title: 'Veuillez confirmer votre date de naissance',
                description: 'Sélectionnez votre date de naissance ci-dessous pour continuer.',
                error: 'La date de naissance que vous avez sélectionnée ne correspond pas à celle de votre profil, veuillez réessayer'
            },
            welcome: {
                title: 'Bienvenue, {0}',
                title_anonymous: 'Bienvenue',
                description: 'Votre message est à un clic.',
                description_two: 'Restez informé et ne manquez jamais une notification importante.'
            },
            create: {
                title: 'Créez votre code PIN',
                description: 'Pour renforcer votre sécurité, veuillez créer un code PIN à 4 chiffres. Vous utiliserez ce code pour vos futures connexions.',
                create_pin: 'Créer un code PIN',
                confirm_pin: 'Confirmer le code PIN',
                submit_pin: 'Valider'
            },
            login: {
                title: 'Connectez-vous',
                description: 'Bon retour ! Veuillez entrer votre code PIN à 4 chiffres pour accéder à vos messages.',
                enter_pin: 'Entrez le code PIN',
                submit_pin: 'Connexion',
                forgot_pin: 'Code PIN oublié ?',
                send_pin: 'Envoyez-moi mon code PIN'
            },
            enter_code: 'Entrez le code',
            forgot_code: 'Code oublié ?',
            view_message: 'Voir le message',
            see_menu: 'Voir le menu',
            dismiss: 'fermer'
        },
        validation: {
            phone_number_required: 'Le numéro de téléphone est requis',
            pin_required: 'Le code PIN est requis',
            pin_pattern: 'Le code PIN doit comporter au moins 4 caractères',
            email_required: 'L\'email est requis',
            email_pattern: 'Email invalide',
            password_required: 'Le mot de passe est requis',
            password_pattern: 'Le mot de passe doit comporter au moins 8 caractères, 1 lettre, 1 chiffre et 1 caractère spécial',
            confirm_required: 'La confirmation est requise',
            confirm_validate: 'Les mots de passe doivent correspondre',
            shared_pin_paragraph: 'Cliquez sur le bouton pour recevoir votre code de vérification',
            forgot_code: 'Code oublié ?',
            send_me_my_login_code: 'Envoyez-moi mon code de connexion'
        },
        links: {
            register: 'Besoin d\'un compte ?',
            forgot: 'Mot de passe oublié ?',
            login: 'Vous avez déjà un compte ?'
        },
        confirm_account: {
            error_title: 'Oh non !',
            error_paragraph: 'Il y a eu une erreur avec votre lien de confirmation. Veuillez vérifier votre email et réessayer.',
            confirmed_title: 'Compte confirmé !',
            confirmed_paragraph: 'Vous pouvez maintenant vous connecter avec votre email et commencer à configurer votre entreprise !',
            confirming: 'Confirmation du compte...'
        },
        forgot_password: {
            success_title: 'Succès !',
            success_paragraph: 'Vérifiez votre email pour un lien de réinitialisation de mot de passe.',
            title: 'Mot de passe oublié'
        },
        reset_password: {
            validating_token: 'Validation du jeton...',
            invalid_link: 'Lien de réinitialisation de mot de passe invalide...',
            success_title: 'Succès !',
            success_paragraph: 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
            title: 'Réinitialiser le mot de passe'
        },
        login: {
            title: 'Bonjour, <br/>bon retour parmi nous !',
            paragraph: 'Entrez votre numéro de téléphone',
            success: 'Connexion réussie !',
            pin_paragraph: 'Un code PIN temporaire a été envoyé à votre téléphone et à votre email (si applicable) - veuillez l\'entrer ci-dessous pour continuer'
        },
        location: {
            what_state: 'Dans quel {0} {1} êtes-vous situé ?',
            choose_state: 'Veuillez sélectionner une province',
            cannot_continue: 'Impossible de continuer',
            merchant_does_not_serve: 'Désolé ! Ce commerçant n\'est pas autorisé à fournir un service dans votre province.',
            location_associated_paragraph: 'Sélectionnez votre programme de magasin',
            location_unassociated_paragraph: 'En voyage ? Cliquez ci-dessous pour vous inscrire à nos autres programmes'
        },
        logout: 'Vous vous êtes déconnecté !',
        register: {
            title: 'Bienvenue chez {0} !',
            paragraph: 'En fournissant votre numéro de téléphone et en cochant la case prévue à cet effet, vous consentez à recevoir des messages texte et des appels marketing, y compris via un système automatique de numérotation téléphonique ou une voix préenregistrée ou artificielle de {0} et de ses filiales, marques et fabricants de produits. Le consentement n\'est pas requis comme condition d\'achat de biens ou de services. Des tarifs standards par minute et par message peuvent s\'appliquer. Désabonnez-vous à tout moment en répondant "END".'
        },
        update_password: {
            title: 'Mettre à jour le mot de passe',
            paragraph: 'Un mot de passe temporaire a été défini sur votre compte. Pour des raisons de sécurité, vous ne pouvez pas continuer tant que vous n\'avez pas défini un nouveau mot de passe. Veuillez définir votre nouveau mot de passe et vous pourrez vous reconnecter.'
        },
        geofence: {
            title: 'Restriction géographique',
            default_subtitle: 'En raison de la politique de l\'app store, cette application ne peut être utilisée que dans les états/provinces où nos magasins sont situés. Partagez votre localisation pour continuer.',
            out_of_state_subtitle: 'Désolé. Nous ne fournissons pas de services dans votre région ({0}, {1} - {2}). En raison de la politique de l\'app store, vous ne pourrez pas accéder à l\'application tant que vous ne serez pas dans le même état/province que nos magasins.',
            out_of_state_manually_subtitle: 'Désolé. Nous ne fournissons pas de services dans votre région ({0}, {1} - {2}). Veuillez sélectionner votre état manuellement si vous pensez qu\'il s\'agit d\'une erreur.',
            blocked_or_denied_subtitle: 'Les permissions de localisation sont requises pour continuer.',
            grant_permissions: 'Accorder les permissions'
        }
    },
    alerts: {
        loyalty_opt_in: 'Adhérez au programme de fidélité',
        loyalty_opt_in_message: 'Vous n\'êtes actuellement pas inscrit à notre programme de récompenses. En fournissant votre signature ci-dessous et en cliquant sur "adhérer", vous serez éligible pour gagner des points de fidélité et échanger des récompenses.',
        text_opt_in: 'Attendez',
        text_opt_in_message: 'Vous ne vous êtes pas inscrit pour recevoir des messages sur les offres spéciales. Retournez en arrière et cochez la case dans les conditions générales pour vous inscrire au marketing par SMS !',
        text_opt_in_message2: 'Êtes-vous sûr de vouloir vous inscrire sans être informé des offres spéciales et promotions ?',
        hipaa_opt_in_message: 'Les informations suivantes sont nécessaires pour finaliser l\'inscription… cochez la case pour HIPAA',
        meta_message: 'Les informations suivantes sont nécessaires pour finaliser l\'inscription…',
        interest_auto_connect: 'Veuillez cliquer sur vos centres d\'intérêt pour activer l\'offre'
    },
    rewards: {
        title: 'Récompenses',
        modal_title: 'Échanger une récompense',
        title_points_rewards: 'Récompenses de {0} points',
        points_redeemable: 'Points échangeables',
        spend_toward_status: 'Dépense pour atteindre le statut',
        redemption_text: 'STOP ! Assurez-vous d\'être avec le personnel AVANT d\'échanger votre récompense. Le personnel doit vous voir échanger pour que vous receviez votre récompense.\nÊtes-vous prêt à échanger votre récompense : {0}',
        redemption_modal_title: 'Échange de récompense',
        redemption_in_store: 'Tellement ravi que vous vouliez échanger vos points ! Veuillez échanger vos points en magasin avant de passer en caisse !',
        available_points: 'points disponibles',
        click_here_to_earn: 'cliquez ici pour commencer à gagner des points',
        expires_at: 'expire {0}',
        return_to: 'retourner à {0}'
    },
    redeem: {
        at: 'Échangé à : {0}',
        valid_until: 'Valide jusqu\'au {0}',
        confirmation: 'Confirmation : {0}',
        confirmation_number: 'Confirmation : {0}',
        go_back: 'retourner au wallet',
        expired: 'Expiré !',
        expires: 'Expire',
        redeemed: 'Échangé',
        redeemed_at: 'Échangé à : {0}',
        back: 'Retourner au wallet',
        with_staff: 'Je suis avec le personnel : procéder à {0}',
        points_needed: 'il vous faut ',
        to_redeem: ' pour échanger {0}',
        point: 'point'
    },
    offers: {
        title: 'Offres',
        title_refer: 'Parrainez un ami',
        modal_title: 'Échanger une offre',
        available_offers: 'Offres disponibles',
        refer_friend: 'Parrainez un ami',
        redemption_text: 'STOP ! Assurez-vous d\'être avec le personnel AVANT d\'échanger votre récompense. Le personnel doit vous voir échanger pour que vous receviez votre récompense.\nÊtes-vous prêt à échanger votre récompense : {0}',
        redemption_modal_title: 'Échange de récompense',
        redemption_in_store: 'Tellement ravi que vous vouliez échanger votre offre ! Veuillez échanger votre offre en magasin avant de passer en caisse !',
        unlock: 'Débloquez cette offre',
        add: 'Ajouter',
        add_birthday: 'Ajouter une date de naissance',
        free_pre_roll: '+ pré-roulé gratuit',
        desirable_action: 'Mettez à jour votre {0} pour gagner {1}',
        no_offers: 'Aucune offre disponible',
        quantity: 'utiliser {0}x'
    },
    milestones: {
        title: 'Étapes importantes',
        spends_remaining: 'Dépensez encore {0} pour débloquer {1}',
        spends_title: 'Dépensez {0} chez {1} pour gagner {2}',
        points_remaining: 'Dépensez encore {0} pour débloquer {1}',
        points_title: 'Dépensez {0} chez {1} pour gagner {2}',
        benefits_title: 'Les avantages incluent :',
        milestone_achieved: 'étape atteinte !',
        congratulations: 'Félicitations ! Vous avez atteint {0}',
        achieved: '{0} atteint !'
    },
    subscriptions: {
        no_plan_message: 'Aucun plan premium disponible',
        title: 'Abonnements',
        get: 'S\'abonner',
        enjoying: 'Gérer le plan',
        active_section: 'Plans actifs',
        explore_section: 'Explorer les plans',
        back_button: 'Retour au wallet',
        benefits: 'Les avantages incluent',
        cancellation_warning: 'Êtes-vous sûr de vouloir annuler votre abonnement ?',
        cancellation_disclaimer: 'En le faisant, vous conserverez vos avantages jusqu\'à la fin de votre période d\'abonnement actuelle.',
        free_trial: 'Les {0} premiers jours sont offerts, puis après cela, c\'est seulement ',
        free_then: '{0} jours gratuits, puis ',
        active_until: 'Actif jusqu\'au {0}',
        renews_on: 'Le plan se renouvelle le {0}',
        update_email_info: 'Mettez à jour vos informations d\' email',
        billing: {
            both: '{0} $ par mois ou {1} $ par an',
            monthly: '{0} $ par mois',
            yearly: '{0} $ par an'
        },
        previously_used: 'précédemment utilisé',
        pricing_title: 'Tarification',
        pricing: '{0}, vous pouvez annuler quand vous le souhaitez',
        email_verification: 'Vérifiez votre email pour recevoir des offres exclusives !',
        terms_prefix: 'J\'ai lu et j\'accepte les ',
        terms_suffix: 'termes et conditions*',
        terms_error: 'Vous devez accepter les termes et conditions',
        next: 'Suivant (2 sur 2)',
        email_field: 'email',
        email_error: 'Un problème est survenu avec votre demande : {0}. Si le problème persiste, veuillez contacter un administrateur',
        details: {
            title: 'Débloquez les avantages premium maintenant !',
            description: 'Passez à notre plan premium dès maintenant et regardez vos économies augmenter. Ne manquez pas les avantages exclusifs et les récompenses imbattables !',
            try_button: 'Continuer',
            try_free_button: 'Essayez gratuitement !'
        },
        code_sent: 'un code a été envoyé à votre boîte de réception',
        code_field: 'code',
        code_resend: 'renvoyer le code',
        change_email: 'changer d\'email',
        verify_email: 'Vérifiez l\'email',
        manage: {
            title: 'Gérer {0}',
            update_email: 'Mettre à jour l\'email',
            change_card: 'Changer de carte',
            cancel_subscription: 'Annuler l\'abonnement'
        },
        success: {
            title: 'Bienvenue chez {0} !',
            description: 'Vous vous êtes abonné avec succès à notre {0}',
            description_two: 'Soyez à l\'affût des offres et promotions exclusives !',
            view_offers_button: 'Voir les offres'
        },
        popups: {
            failed_payment: {
                title: 'Paiement échoué',
                text: 'Pour conserver le plan premium, mettez à jour votre méthode de paiement dès que possible',
                button: 'Mettre à jour'
            },
            sub_prompt: {
                title: 'Rejoignez notre club VIP pour des offres exclusives',
                button: 'Cliquez ici pour en savoir plus',
                dismiss: 'Ne me le rappelez pas'
            }
        }
    },
    credit_card: {
        choose_plan: 'Choisissez votre plan',
        monthly_title: 'Mensuel',
        monthly_price: '${0}/mois',
        monthly_summary: 'Payez ${0} par mois. Annulez à tout moment.',
        yearly_title: 'Annuel',
        yearly_price: '${0}/an',
        yearly_summary: 'Payez ${0} par an. Annulez à tout moment.',
        free_trial: '{0} jour d\'essai gratuit',
        add_card: 'Ajouter les informations de carte',
        name: 'nom du titulaire de la carte',
        number: 'numéro de la carte',
        cvv: 'CVV',
        expiry: 'date d\'expiration',
        zip_code: 'code postal',
        subscribe_button: 'S\'abonner',
        cancel_button: 'Annuler'
    },
    profile: {
        title: 'Profil',
        my_account: 'Mon compte',
        phone: 'Mon téléphone :',
        email: 'Mon email :',
        birthday: 'Mon anniversaire :',
        greetings: 'Bonjour, {0}',
        spend_toward_status: '{0} Dépensez pour le statut',
        upload_profile: 'Télécharger l\'image du profil',
        choose_from_library: 'Choisir dans la bibliothèque',
        take_photo: 'Prendre une photo',
        cancel: 'annuler',
        edit: 'éditer',
        remove_photo: 'Supprimer la photo',
        profile_image_added: 'Image de profil ajoutée.',
        profile_image_removed: 'Image de profil supprimée.',
        profile_updated: 'Profil mis à jour avec succès !',
        undo: 'annuler'
    },
    profileMenu: {
        my_information: 'Mes informations',
        recent_history: 'Historique récent',
        message_notifications: 'Paramètres des messages et des notifications',
        terms_condition: 'Termes et conditions',
        privacy_policy: 'Politique de confidentialité'
    },
    accountInformation: {
        delete_account_title: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
        delete_account_message: 'En faisant cela, tous vos points de fidélité gagnés seront supprimés et ne seront plus disponibles pour vous, et vous serez désinscrit de la réception de tous les messages de ce détaillant. Une fois que vous avez supprimé votre compte, cette action sera permanente et ne pourra pas être annulée.',
        delete_account: 'Supprimer le compte',
        delete_account_header_title: 'Un code PIN temporaire a été envoyé à votre téléphone. Entrez-le ci-dessous pour confirmer que vous souhaitez supprimer votre compte.'
    },
    refer: {
        title: 'Parrainez un ami',
        copy_link: 'Copier le lien',
        text_prize: 'Lorsque l\'un de vos amis rejoint sur votre parrainage, vous recevrez un',
        text_prize_purchase: 'Lorsque l\'un de vos amis dépense {0} grâce à votre parrainage, vous recevrez un',
        prize: '30% de réduction sur un achat',
        text_receiver: 'et ils recevront',
        pre_rolled_reward: 'un pré-roulé gratuit',
        text_link: 'Copiez et partagez le lien ci-dessous avec vos amis ou montrez à vos amis votre code QR unique ci-dessus pour une inscription facile.',
        text_social_media: 'N\'oubliez pas de partager votre lien sur les réseaux sociaux !'
    },
    interests: {
        title: 'Intérêts'
    },
    messages: {
        title: 'Centre de messages',
        no_messages: 'Aucun message',
        shop_now: 'Acheter maintenant'
    },
    anylink: {
        view_more: 'Voir plus',
        view_offers: 'Voir les offres',
        view_rewards: 'Voir les récompenses',
        view_profile: 'Voir le profil',
        view_info: 'Voir mes informations',
        view_interests: 'Voir les intérêts',
        view_refer: 'Voir le lien de parrainage',
        shop_online: 'Acheter en ligne',
        view_gift_card: 'Voir {0}'
    },
    settings: {
        header_title: 'Paramètres de communication',
        modal_title: 'Opter pour le marketing par email',
        modal_paragraph: 'Acceptez les termes {0}et cochez la case ci-dessous pour vous inscrire au {1}',
        modal_terms_and_conditions: 'En complétant ce formulaire d\'inscription et en participant à notre programme, vous consentez à notre {0}',
        sms_opt_in_disclaimer: 'En sélectionnant cette case, je consens à recevoir des appels et des messages texte informatifs et marketing de {0} et de ses filiales, y compris envoyés par des moyens automatisés ou préenregistrés, au numéro fourni. Le consentement n\'est pas une condition d\'achat. Répondez STOP pour vous désabonner. Des frais de message et de données peuvent s\'appliquer. Consultez les termes et la politique de confidentialité pour plus d\'informations.',
        email_opt_in_disclaimer: 'En sélectionnant cette case, je consens à recevoir des emails informatifs et marketing de {0} et de ses affiliés, y compris envoyés par des moyens automatisés ou préenregistrés, à l\'adresse email fournie. Le consentement n\'est pas une condition d\'achat. Consultez les termes et la politique de confidentialité pour plus d\'informations.',
        loyalty_opt_in_disclaimer: '',
        text_message: 'Messages texte',
        push_notifications: 'Notifications push',
        email_notifications: 'Notifications par email'
    },
    history: {
        title_purchases: 'Achats',
        title_redemptions: 'Remboursements',
        transaction_total: 'Total de la transaction',
        item_ordered: 'Articles commandés',
        category: 'Catégorie',
        brand: 'Marque',
        product_name: 'Nom du produit',
        redeemed: 'échu',
        points: 'points'
    },
    general: {
        accept: 'Accepter',
        address1: 'Adresse 1',
        address2: 'Adresse 2',
        back: 'Retour',
        birthday: 'Anniversaire',
        cancel: 'Annuler',
        cart: 'Panier',
        city: 'Ville',
        confirm_password: 'Confirmer le mot de passe',
        continue: 'Continuer',
        delete: 'Supprimer',
        edit: 'Modifier',
        email: 'Email',
        female: 'Femme',
        first_name: 'Prénom',
        gender: 'Sexe',
        get: 'Obtenir',
        use: 'Utiliser',
        earning: 'Gains',
        unlimited: 'illimité',
        go_back: 'Retourner',
        last_name: 'Nom de famille',
        loading: 'Chargement',
        login: 'Connexion',
        male: 'Homme',
        merchant: 'Commerçant',
        messages: 'Centre de messages',
        new_password: 'Nouveau mot de passe',
        offers: 'Offres',
        old_password: 'Ancien mot de passe',
        other: 'Autre',
        password: 'Mot de passe',
        phone_number: 'Numéro de téléphone',
        pin: 'Entrer le code',
        press_to_sign: 'Appuyez pour signer',
        privacy_policy: 'Politique de confidentialité',
        profile: 'Profil',
        redeemed: 'Réclamé',
        region: 'État/Région',
        rewards: 'Récompenses',
        save: 'Sauvegarder',
        select_date: 'Sélectionner la date',
        sign_below: 'Veuillez signer ci-dessous',
        signature_saved: 'Signature enregistrée',
        signature: 'Signature',
        submit: 'Soumettre',
        success: 'Succès',
        terms_and_conditions: 'Termes et conditions',
        zip: 'Code postal',
        select_language: 'Sélectionner la langue',
        add: 'ajouter',
        interest: 'intérêt',
        update: 'mettre à jour',
        updated: 'mis à jour',
        email_example: 'exemple@mail.com',
        how_did_you_hear_about_us: 'Comment avez-vous entendu parler de nous ?',
        favorite_location: 'Lieu préféré',
        wallet_terms: 'Termes et conditions',
        submitError: 'Il y a eu un problème lors du traitement de votre demande, veuillez réessayer plus tard',
        amount: 'montant',
        payment: 'paiement',
        location: 'emplacement',
        points: 'points',
        send: 'envoyer',
        enabled: 'activé',
        disabled: 'désactivé',
        download_app: 'Télécharger'
    },
    errors: {
        invalid_email: 'Veuillez entrer un email valide',
        birthday_in_past: 'Veuillez sélectionner une date dans le passé'
    },
    cart: {
        no_website: 'Aucun site web disponible'
    },
    apiErrors: {
        postJoinPhone: 'Erreur lors de la soumission du numéro de téléphone',
        getJoinPin: 'Erreur lors de la soumission du code PIN',
        getWalletMember: 'Erreur lors de la récupération du wallet',
        getWalletMilestones: 'Erreur lors de la récupération des jalons',
        postWalletRedemption: 'Erreur lors de la réclamation des récompenses',
        getNativeMerchantOrgs: 'Erreur lors de la récupération des lieux',
        getNativeAppStashboardKeys: 'Erreur lors de la récupération des clés de message',
        getNativeAppStashboard: 'Erreur lors de la récupération des informations de message',
        getNativeAppRewardRedemption: 'Erreur lors de la réclamation des récompenses',
        getNativeAppVisit: 'Erreur lors de la réception de la visite',
        putNativeAppSync: 'Erreur lors de la synchronisation',
        patchNativeAppUpdate: 'Erreur lors de la mise à jour de votre membre',
        postNativeAppCreate: 'Erreur lors de la création de votre membre'
    },
    navigation: {
        menu: 'Menu',
        cart: 'Panier',
        messages: 'Messages',
        profile: 'Profil',
        rewards: 'Récompenses',
        offers: 'Offres',
        refer: 'Référer',
        milestones: 'Etapes',
        subscriptions: 'Abonnements',
        select_store: 'Sélectionner le magasin',
        springbigpay: 'Payer',
        accountHistory: 'Historique des achats',
        home: 'Accueil'
    },
    giftCard: {
        field: {
            amount: 'montant',
            method: 'méthode de paiement',
            loyalty: 'sélectionner une carte de fidélité'
        },
        manage: {
            success: 'informations de paiement supprimées avec succès',
            error: 'une erreur est survenue lors de la suppression de vos informations de paiement, veuillez contacter un administrateur'
        },
        more_info: 'plus d\'infos',
        fund_with_points: 'alimenter {0} avec des points',
        points_for: 'points pour',
        select_card: 'sélectionner {0}',
        add_cc: 'Ajouter carte de crédit/débit',
        cards: 'cartes',
        plus_payment: '+ paiement',
        other: 'autre',
        manage_funds: 'gérer les fonds',
        reloadable: 'rechargeable',
        non_reloadable: 'non rechargeable',
        on: 'activé',
        off: 'désactivé',
        locations: 'emplacements',
        used_at: 'peut être utilisé à:',
        no_access: 'aucun accès',
        claimBefore: 'réclamez avant {0}',
        claimNow: 'Réclamez maintenant',
        claim: 'Réclamer',
        claiming: 'en cours de réclamation...',
        claimEmailVerifyHeader: 'Veuillez vérifier votre email pour réclamer votre {0}',
        claimSuccess: '{0} réclamé !',
        bannerHeading: 'Nouveaux {0}s vous attendent',
        inboxHeading: '{0}s disponibles',
        inboxEmailNotValidatedHeading: 'Vérifiez votre email pour réclamer vos {0}s',
        inboxGrantsAvailable: 'Vous avez des {0}s non réclamés qui nécessitent votre attention.',
        claimBeforeExpiration: 'Réclamez-les avant qu’ils n’expirent!',
        claimExtraNote: 'Remarque : les {0}s doivent être réclamés pour être crédités sur votre compte.',
        inboxGrantsClaimed: '{0}s ajoutés à votre portefeuille',
        balanceUpdated: 'Votre solde de {0} a été mis à jour!',
        description: '{0} {1}',
        addedOn: 'ajouté {0}',
        navigateTo: 'Aller à {0}s',
        balanceAddedHeading: '{0} ajouté à votre solde de {1}!',
        inboxSendCodeButton: 'Envoyer le code',
        inboxBannerHeading: 'Nouveaux {0}s vous attendent',
        inboxBannerSubHeading: 'Vous avez une activité de {0} sur votre compte',
        inboxBannerButton: 'Vérifiez maintenant',
        totalCards: 'total des cartes',
        noCards: 'aucune carte disponible',
        addCash: 'ajouter des fonds en espèces',
        pinCode: 'code PIN: {0}',
        sendToFriend: 'envoyer un {0} à un ami',
        importExistingButton: 'importer un {0} existant',
        emailVerificationTitle: 'Veuillez vérifier votre email. Cela permet de sécuriser votre compte!',
        nameCompletionFormTitle: 'Complétez votre profil pour continuer',
        primary: {
            title: 'carte principale',
            button: 'définir comme principale'
        },
        barcode: {
            view: 'voir le code-barres'
        },
        update: {
            success: 'carte mise à jour avec succès',
            error: 'une erreur est survenue lors de la mise à jour de cette carte en carte principale, veuillez réessayer plus tard.'
        },
        balance: {
            manage_cash: 'gérer les fonds',
            cash_balance: 'solde en espèces',
            point_balance: 'solde de points',
            convert_points_cash: 'convertir des points en espèces'
        },
        autoReload: {
            updateStatus: 'Auto-Recharge'
        },
        addFunds: {
            fundWithPoints: 'alimenter {0} avec des points',
            reloadSuccess: 'carte rechargée avec succès',
            createSuccess: 'carte créée et chargée avec succès',
            title: 'ajouter des fonds',
            autoReload: {
                title: 'paramètres de rechargement automatique',
                subTitle: 'rechargement automatique',
                belowbalance: 'lorsque le solde est inférieur à',
                amount: 'montant de la recharge',
                payment: 'méthode de paiement'
            },
            conditions: {
                fees: '* des frais de traitement supplémentaires de {0} seront ajoutés'
            }
        },
        addPayment: {
            addBank: {
                caption: 'connecter un compte bancaire',
                form: {
                    name: {
                        title: 'nom du compte bancaire *',
                        error: 'le numéro de compte est requis et doit être dans un format valide'
                    },
                    number: {
                        title: 'numéro de compte *',
                        error: 'le nom du compte bancaire est requis'
                    },
                    routingNumber: {
                        title: 'numéro de routage *',
                        error: 'le numéro de routage est requis et doit être dans un format valide'
                    }
                }
            },
            addCard: {
                caption: 'carte de crédit/débit',
                form: {
                    name: {
                        title: 'nom sur la carte *',
                        error: 'le nom sur la carte est requis et ne doit pas contenir de caractères spéciaux ni de chiffres'
                    },
                    number: {
                        title: 'numéro de carte*',
                        error: 'le numéro de carte est requis et doit comporter entre 14 et 19 chiffres'
                    },
                    cvv: {
                        title: 'cvv*',
                        error: 'le cvv est requis et doit comporter 3 chiffres'
                    },
                    expiryDate: {
                        title: 'date d\'expiration*',
                        error: 'la date d\'expiration est requise et doit être au format mm/aa'
                    },
                    zip: {
                        title: 'code postal*',
                        error: 'le code postal est requis et doit être composé de 6 lettres ou chiffres'
                    }
                }
            }
        },
        restrictions: {
            points_limit: 'Votre seuil de recharge individuel actuel pour cette période est de {0} et jusqu\'à {1} au total',
            cash_limit: 'Votre seuil de recharge individuel actuel pour cette période est de {0} et jusqu\'à {1} au total',
            one_time_point_limit_under: 'Votre seuil de recharge pour cette période est de {0} sur {1}',
            one_time_dollar_limit_under: 'Votre seuil de recharge pour cette période est de {0} sur {1}',
            one_time_point_limit_over: 'Votre seuil de recharge individuel pour cette période est de {0}. Votre recharge restante pour cette période est de {1} sur {2}',
            one_time_dollar_limit_over: 'Votre seuil de recharge individuel pour cette période est de {0}. Votre recharge restante pour cette période est de {1} sur {2}',
            information: {
                cash_title: 'Paiements par carte:',
                cash_one_time: 'Votre montant maximal de recharge individuel est de {0}',
                cash_per_period: 'Votre montant global maximal est de {0}',
                cash_period: 'Se renouvelle tous les {0} jours',
                points_title: 'Remboursements de points:',
                points_one_time: 'Votre conversion maximale de points est de {0}',
                points_per_period: 'Votre conversion globale maximale est de {0}',
                points_period: 'Se renouvelle tous les {0} jours'
            }
        },
        pointsConvertor: {
            title: 'convertir des points en espèces',
            notEnoughPoints: 'vous n\'avez pas suffisamment de points',
            pointsFor: 'points pour',
            reloadSuccess: 'carte rechargée avec succès',
            selectRoyaltyError: 'veuillez sélectionner une carte de fidélité pour continuer',
            form: {
                accountNumber: {
                    placeholder: 'Numéro de compte'
                }
            }
        },
        send: {
            title: 'envoyer {0} à un ami',
            sent: {
                title: '{0} envoyé!',
                amount: 'montant: {0}',
                to: 'à : {0}'
            },
            form: {
                email: {
                    title: 'adresse email de l\'ami',
                    error: 'veuillez entrer une adresse email valide'
                }
            }
        },
        received: {
            disclaimer: 'vous avez reçu un {0}!',
            title: 'nouveau {0} reçu',
            button: 'ajouter au wallet',
            from: 'de : {0}'
        },
        add: {
            title: 'ajouter un {0}',
            uploadButton: 'télécharger un {0} existant',
            fundButton: 'alimenter votre nouveau {0}'
        },
        importExisting: {
            title: 'importer un {0} existant',
            form: {
                number: {
                    title: '{0} numéro*',
                    error: 'le numéro de carte est requis et doit comporter 19 chiffres'
                },
                pin: {
                    title: 'code PIN*',
                    error: 'le code PIN est requis et doit comporter 4 chiffres'
                }
            },
            currentBalance: 'solde actuel {0}',
            submitButton: 'ajouter la carte au wallet',
            error: 'une erreur est survenue lors de l\'importation de votre carte, veuillez réessayer plus tard',
            success: 'votre carte a été importée avec succès'
        },
        deleteCardsModal: {
            title: 'Nettoyer',
            description: 'En choisissant cette option, vous éliminerez les cartes inutilisées ou celles avec un solde restant de 0',
            disclaimer: 'Cette action ne peut pas être annulée',
            backButton: 'Retour au wallet',
            confirmButton: 'Nettoyer le wallet'
        },
        transactions: {
            title: 'historique de rechargement de {0}',
            greeting: 'Bonjour, {0}',
            lastUpdated: 'dernière mise à jour {0}',
            noTransactions: 'Vous n\'avez pas d\'historique de rechargement',
            back: 'retour à la page d\'accueil',
            nextPage: 'page suivante',
            prevPage: 'page précédente',
            total: 'total {0}',
            pageOf: 'page {0} sur {1}',
            view_transaction: 'voir l\'historique des rechargements',
            transaction_points: '{0} points',
            processing_fee: '+ {0} frais',
            card_load: 'rechargement de carte',
            empty_state: 'Vous n\'avez pas d\'historique de rechargement',
            details: {
                titleLoadAmount: 'Montant du rechargement',
                titleDate: 'Date',
                id: 'ID de la transaction: {0}',
                date: 'date de la transaction',
                status: 'statut de la transaction',
                type: 'type de transaction',
                nmi: 'paiement par carte',
                points_for_cash: 'conversion de points',
                offer_extension: 'extension d\'offre',
                referenceId: 'ID de référence de la transaction',
                fee: 'frais de transaction',
                total: 'total de la transaction',
                currency: 'devise de la transaction',
                last4digit: 'derniers 4 chiffres de la carte',
                providerId: 'ID du fournisseur de paiement',
                loadAmount: 'montant du rechargement de la carte',
                pointsRedeemed: 'points échangés',
                giftCardDigits: 'derniers 4 chiffres de la carte',
                reward: 'récompense'
            }
        }
    },
    suspended_account: {
        disclaimer: 'Cher client, nous vous remercions de votre fidélité. Nous sommes en train de renouveler notre accord de programme de fidélité. Pendant que nous finalisons les détails de ce renouvellement, nous tenons à vous assurer que les points' + ' et les récompenses que vous avez accumulés avec nous sont 100% sûrs et en sécurité. L\'accès à votre wallet de fidélité sera rétabli dès que possible. Nous nous excusons pour tout désagrément que cela pourrait causer.' + ' N\'hésitez pas à contacter notre équipe en magasin si vous avez des questions ou des préoccupations.'
    },
    shop: {
        title: 'Boutique',
        filters: 'appliquer les filtres',
        apply_filters: 'appliquer les filtres',
        active_filters: 'Filtres actifs',
        clear_filters: 'effacer',
        between_price_filter: 'entre ${0} et ${1}',
        sort: 'trier par :',
        in: 'dans',
        favorite_brands: 'marques préférées',
        search: 'Rechercher',
        see_all: 'voir tout',
        cart_empty: 'votre panier est vide',
        apply: 'appliquer',
        oops: 'Oups!',
        we_cant_find: 'Nous ne pouvons pas trouver vos commandes précédentes.',
        add_your_email: 'Ajoutez votre email ici pour voir vos commandes précédentes',
        add_email: 'ajouter un email',
        x: 'x',
        subtotal: 'sous-total :',
        fees: 'frais :',
        taxes: 'taxes :',
        discounts: 'réductions :',
        total: 'total :',
        back: 'retour',
        order_number: 'numéro de commande :',
        order_submitted: 'Commande soumise!',
        return_to_app: 'Retour à l\'application',
        at: 'à',
        delivery: 'livraison',
        pickup: 'ramassage',
        items: 'articles',
        see_past_orders: 'voir les commandes passées',
        go_to_checkout: 'aller à la caisse',
        back_to_store: 'retourner à la boutique',
        see_fulfillment_hours: 'voir les horaires de traitement',
        some_fulfillment_options: '* certaines options de traitement peuvent ne pas être disponibles en raison des horaires de commande -',
        would_you_like_to_continue: 'Souhaitez-vous continuer ?',
        due_to_differences: 'En raison de différences dans l\'inventaire et la tarification, en changeant votre emplacement, vous perdrez toute progression de commande.',
        directions: 'directions',
        call: 'appeler',
        view_cart: 'voir le panier',
        add_to_cart: 'ajouter au panier',
        add: 'ajouter',
        thc: 'thc : ',
        cbd: 'cbd : ',
        add_item: 'ajouter un article',
        view_details: 'voir les détails',
        reorder: 'commander à nouveau',
        item: 'article',
        s: 's',
        grant_permission: 'accorder l\'autorisation',
        grant_permission_info: 'Les autorisations de localisation sont requises pour effectuer des achats en ligne',
        your_orders: 'vos commandes',
        pick_your_location: 'Choisissez votre emplacement',
        location_and_method: 'emplacement et méthode',
        no_matching_location: 'Aucun magasin ne correspond à votre critère de recherche',
        distance: 'Distance',
        update_your_email: 'Mettez à jour votre email',
        grant_location_permission: 'Accorder l\'autorisation de localisation',
        location_permissions_are_required: 'Les autorisations de localisation sont requises pour faire des achats en ligne',
        permissions_can_be_reset: 'Les autorisations peuvent être réinitialisées dans vos préférences ou en cliquant sur l\'icône dans la barre d\'adresse',
        alert: 'alerte'
    },
    payment: {
        manage: 'gérer',
        manage_payments: 'gérer les paiements',
        cards_on_file: 'cartes enregistrées',
        new_card: '+ nouvelle carte',
        add: 'ajouter',
        remove: 'supprimer',
        save: 'enregistrer'
    },
    home_page: {
        named_greetings: 'Bonjour, ',
        anonymous_greetings: 'Bonjour!',
        edit: 'modifier',
        save: 'enregistrer',
        view_more: 'voir plus',
        filters: {
            total: 'total',
            week: 'derniers 7 jours'
        },
        subscriptions: {
            title: 'abonnements',
            benefits: 'Avantages',
            see_benefits: 'voir les avantages'
        },
        gift_cards: {
            title: '{0}',
            manage_funds: 'gérer les fonds',
            view_all: 'voir toutes les cartes',
            view_barcode: 'voir les codes-barres',
            card_balance: 'solde de la carte ${0}',
            back: 'retour'
        },
        milestones: {
            title: 'jalons',
            spend_title: 'Jalons de dépenses',
            points_title: 'Jalons de points'
        },
        referrals: {
            title: 'parrainez un ami',
            copy_link: 'copier le lien',
            copied_link: 'lien copié',
            offers_earned: 'offres gagnées',
            referred: 'référé'
        },
        messages: {
            title: 'messages',
            unread: 'non lus',
            caught_up: 'vous avez tout vu!',
            previous: 'voir les précédents'
        },
        rewards: {
            title: 'récompenses',
            earned: 'gagnées',
            redeemed: 'échangées',
            highest: 'le plus élevé disponible',
            get: 'obtenir',
            value: '{0} points'
        },
        offers: {
            title: 'offres',
            earned: 'gagnées',
            redeemed: 'échangées',
            latest: 'dernières',
            get: 'obtenir',
            expiration: 'exp {0}',
            redemptions: 'utiliser x{0}'
        },
        bonus_points: {
            title: 'points bonus'
        },
        point_balance: {
            title: 'solde des points',
            learn_more: 'apprenez comment gagner plus de points',
            total_points: 'total des points',
            last_earned: 'dernier gagné',
            bonus_points: {
                title: 'points bonus',
                get: 'utiliser x{0}',
                unlimited: 'obtenir',
                earning: 'gagner',
                earning_prefix_multiplication: 'gagnez x{0} points',
                earning_prefix_addition: 'gagnez {0} points',
                expiration: 'exp {0}'
            },
            and: 'et',
            or: 'ou',
            bonus_rules: {
                day_of_the_week: 'le {0}',
                order_source: 'lorsque vous commandez {0}',
                transaction_location: 'lorsque vous magasinez chez {0}',
                time_of_day_range: 'entre {0} et {1}',
                points_earned_range: 'lorsque vous dépensez entre {0} et {1} points',
                transaction_total_range: 'lorsque vous dépensez entre ${0} et ${1}',
                earning_prefix_multiplication: 'gagnez x{0} points'
            },
            week_days: {
                0: 'dimanches',
                1: 'lundis',
                2: 'mardis',
                3: 'mercredis',
                4: 'jeudis',
                5: 'vendredis',
                6: 'samedis'
            },
            locations: {
                instore: 'en magasin',
                ecommerce_delivery: 'par livraison e-commerce',
                ecommerce_pickup: 'par retrait e-commerce',
                ecommerce: 'par e-commerce'
            }
        }
    }
};
const _default = lang;
